import { put, takeLatest, delay } from "redux-saga/effects";
import { hideOtpModal } from "./otpModalSlice";
import OTP_MODAL_TYPES from "./otpModalTypes";

function* autoHideOtpModal() {
  yield delay(3000); // wait for 3 seconds
  // yield put(hideOtpModal());
}

export default function* watchOtpModalSaga() {
  yield takeLatest(OTP_MODAL_TYPES.SHOW_OTP_MODAL, autoHideOtpModal);
}
